import { stores } from '@kurtosys/app-start';
import { requests } from '@kurtosys/ksys-api-client';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { computed, makeObservable } from 'mobx';

import { IComponentStyles, IConfiguration, TStoreContext } from '../../../models';
type TRetrieveDocument = requests.documents.RetrieveDocument;
type TRetrieveDocumentZip = requests.documents.RetrieveDocumentZip;

const KurtosysApiStoreBase = stores.KurtosysApiStore<IConfiguration, IComponentStyles>;
const RetrieveDocument = requests.documents.RetrieveDocument;
const RetrieveDocumentZip = requests.documents.RetrieveDocumentZip;

export class KurtosysApiStore extends KurtosysApiStoreBase {
	constructor(storeContext: TStoreContext, manifest: IManifest) {
		super(storeContext, manifest);
		makeObservable(this);
	}

	@computed
	get retrieveDocument(): TRetrieveDocument {
		return this.createEndpoint(RetrieveDocument);
	}

	@computed
	get retrieveDocumentZip(): TRetrieveDocumentZip {
		return this.createEndpoint(RetrieveDocumentZip);
	}
}
